module.exports = __webpack_public_path__ + "img/QR_active.bfb6e4db.png";